import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolves CMS-uploaded media paths and external URLs alike.
export const fileUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND_URL}${u}` : u);
